export default __webpack_public_path__ + "static/media/ThreePigs_01.ba7f31b7.png";